var App = App || {};

App.WhyUsBand = (function ($) {
    'use strict';

    var LgBp = 992,
        winTouchPoint,
        activeElem;

    function init() {

        var $whyUsBand = $(".component-whyusband");
        var $whyUsSlider = $(".whyusband-slider");
        var $controlPrev = $whyUsBand.find('.slider-prev'),
            $controlNext = $whyUsBand.find('.slider-next');

        if ($whyUsSlider.length) {

            // nav button scrolling
            $controlNext.on("click", function () {
                if ($(".whyusband-slider .whyusband-card-wrapper.active").next().length) {
                    giveNextActive();
                    $whyUsSlider.animate({ scrollTop: $(".whyusband-slider .whyusband-card-wrapper.active").attr("data-offset") });
                }
            });
            $controlPrev.on("click", function () {
                if ($(".whyusband-slider .whyusband-card-wrapper.active").prev().length) {
                    givePrevActive();
                    $whyUsSlider.animate({ scrollTop: $(".whyusband-slider .whyusband-card-wrapper.active").attr("data-offset") });
                }
            });

            var currentScrollTop = 0,
                lastScrollTop = 0,
                sliderTop,
                activeTop,
                sliderDifferential;

            $whyUsSlider.scroll(function (e) {
                sliderTop = $(".whyusband-slider").offset().top;
                activeTop = $(".whyusband-slider .whyusband-card-wrapper.active").offset().top;
                sliderDifferential = sliderTop - activeTop;
                currentScrollTop = $(this).scrollTop();

                //keep active card roughly in line when scrolling via mouse or drag to let nav buttons stay relevant
                if (currentScrollTop > lastScrollTop && sliderDifferential > 0) {
                    if ($(".whyusband-slider .whyusband-card-wrapper.active").next().length) {
                        giveNextActive();
                    }
                }
                else if (currentScrollTop < lastScrollTop && sliderDifferential < $(".whyusband-slider .whyusband-card-wrapper.active").outerHeight() / -3) {
                    if ($(".whyusband-slider .whyusband-card-wrapper.active").prev().length) {
                        givePrevActive();
                    }
                }
                lastScrollTop = currentScrollTop;
            });

            $(document).ready(function () {
                winTouchPoint = $(window).outerWidth();
                resetSliderToFirst($whyUsSlider)
                //alternate justification
                $(".whyusband-slider .whyusband-card-wrapper:nth-child(even)").each(function () {
                    $(this).find(".whyusband-card").addClass("right-aligned")
                });

                calculateOffsets($(".whyusband-slider").offset().top)

                repositionNav();
            });

            $(window).resize(function () {
                repositionNav();

                if ($(window).outerWidth() >= LgBp && winTouchPoint < LgBp) {
                    winTouchPoint = $(window).outerWidth();
                    resetSliderToFirst($whyUsSlider)
                } else if ($(window).outerWidth() < LgBp && winTouchPoint >= LgBp) {
                    winTouchPoint = $(window).outerWidth();
                    resetSliderToFirst($whyUsSlider);
                }
            });
        };
    }

    function resetSliderToFirst($whyUsSlider) {
        //reset slider to first position to recalculate card offset as cards change size
        $whyUsSlider.animate({ scrollTop: 0 }, 0);
        $(".whyusband-slider .whyusband-card-wrapper").removeClass("active").find('a').attr("tabindex", "-1");
        $(".whyusband-slider .whyusband-card-wrapper").first().addClass("active").find('a').attr("tabindex", "0");

        calculateOffsets($(".whyusband-slider").offset().top);
    }

    function calculateOffsets(sliderTop) {
        //calculate offset used by nav buttons
        $(".whyusband-slider .whyusband-card-wrapper").each(function () {
            $(this).attr("data-offset", $(this).offset().top - sliderTop);
        });
    }

    function giveNextActive() {
        activeElem = $(".whyusband-slider .whyusband-card-wrapper.active");
        activeElem.removeClass("active").find('a').attr("tabindex", "-1");
        activeElem.next().addClass("active").find('a').attr("tabindex", "0");
    }

    function givePrevActive() {
        activeElem = $(".whyusband-slider .whyusband-card-wrapper.active");
        activeElem.removeClass("active").find('a').attr("tabindex", "-1")
        activeElem.prev().addClass("active").find('a').attr("tabindex", "0");
    }

    function repositionNav() {
        //position nav buttons
        if ($(window).outerWidth() >= LgBp) {
            $(".slider-nav").css("top", "25%");
        } else if ($(window).outerWidth() < LgBp) {
            $(".slider-nav").css("top", $(".whyusband-inner .col").first().outerHeight(true));
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.WhyUsBand.init();
});